import React, {FunctionComponent} from "react";
import {Col, Input} from "reactstrap";
import {OrderBasicWithReferenceItemsSelectable, OrderStateMap} from "../../../../interfaces/OrderInterfaces";
import Badge from "../../../atoms/Badge";
import {useIntl} from "react-intl";
import {dateUtils} from "../../../../utils/dateUtils";

interface OrderItemsFormTableRowProps {
  order: OrderBasicWithReferenceItemsSelectable,
  ordersSelectable: OrderBasicWithReferenceItemsSelectable[]
  setOrdersSelectable: (orders: OrderBasicWithReferenceItemsSelectable[]) => void
  onRowClick?: (orderId: string) => void,
}

const OrderItemsFormTableRow: FunctionComponent<OrderItemsFormTableRowProps> = ({
  order,
  ordersSelectable,
  setOrdersSelectable,
  onRowClick
}) => {
  const intl = useIntl()

  function handleHeadRowValueChanges(value: OrderBasicWithReferenceItemsSelectable, checked: boolean) {
    setOrdersSelectable(ordersSelectable.map(order => {
      if (order.id === value.id) {
        return {
          ...order,
          isSelected: checked,
          itemsWithReference: order.itemsWithReference.map(orderItem => ({...orderItem, isSelected: checked}))
        }
      }
      return order
    }))
  }

  return (
    <div onClick={() => onRowClick(order.id)} className="epow-custom-table-row details-table">
      <div className="epow-custom-table-row-main order-table-row py-2">
        <Col xs={1} onClick={(event) => { { event.preventDefault(); event.stopPropagation() } }}>
          <Input
            className="ms-2"
            type="checkbox"
            checked={order.isSelected}
            onChange={() => {
              handleHeadRowValueChanges(order, !order.isSelected)
            }}
          />
        </Col>
        <Col className="me-3" md={3}>
          {order.customerName}
        </Col>
        <Col md={3}>
          {order.customerReference}
        </Col>
        <Col md={5}>
          {dateUtils.formatDateDayJs(order.beginTourDate)}
        </Col>
        <Col md={5}>
          {order.itemsWithReference.length} prestation{order.itemsWithReference.length > 1 && "s"}
        </Col>
        <Col md={2}>
          <Badge pill color={OrderStateMap[order.orderStatus]?.color}>
            {intl.formatMessage({id: OrderStateMap[order.orderStatus]?.label})}
          </Badge>
        </Col>
      </div>
    </div>
  )
}

export default OrderItemsFormTableRow
